import { useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

export type SharedGuideType = "comparison" | "property" | "field_guide";

const recordedShareLandings = new Set<string>();

export function useGuideShareLanding(guideType: SharedGuideType | null) {
  useEffect(() => {
    if (!guideType || typeof window === "undefined") return;
    const referral = new URLSearchParams(window.location.search).get("ref");
    if (referral !== "share") return;
    const landingKey = `${window.location.pathname}:${guideType}`;
    if (recordedShareLandings.has(landingKey)) return;
    recordedShareLandings.add(landingKey);
    trackEvent("guide_share_landing", { guide_type: guideType });
  }, [guideType]);
}
